<div class="modal-header">
    <h4 class="modal-title">User Information</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
    <table class="table table-borderless table-sm">
        <tbody>
        <tr>
            <td class="font-weight-bold">Display Name</td>
            <td>{{universityPerson.displayName}}</td>
        </tr>
        <tr>
            <td class="font-weight-bold">HawkID</td>
            <td>{{universityPerson.hawkId}}</td>
        </tr>
        <tr>
            <td class="font-weight-bold">UnivID</td>
            <td>{{universityPerson.univId}}</td>
        </tr>
        <tr>
            <td class="font-weight-bold">EmplID</td>
            <td>{{universityPerson.emplId}}</td>
        </tr>
        <tr>
            <td class="font-weight-bold">Email</td>
            <td>{{universityPerson.email}}</td>
        </tr>
        <tr>
            <td class="font-weight-bold">Campus Address</td>
            <td>{{universityPerson.campusAddress}}</td>
        </tr>
        <tr>
            <td class="font-weight-bold">Department</td>
            <td>{{universityPerson.department}}</td>
        </tr>
        <tr>
            <td class="font-weight-bold">Phone</td>
            <td>{{universityPerson.phone}}</td>
        </tr>
        </tbody>
    </table>
</div>